import { render, staticRenderFns } from "./smallOrderDetail.vue?vue&type=template&id=2740af50&scoped=true"
import script from "./smallOrderDetail.vue?vue&type=script&lang=js"
export * from "./smallOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./smallOrderDetail.vue?vue&type=style&index=0&id=2740af50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2740af50",
  null
  
)

export default component.exports